import { useMemo } from "react";
import useStyle from "src/hooks/useStyle";
import IconCheck from "src/icons/IconCheck";
import IconClipboard from "src/icons/IconClipboard";
import IconLink from "src/icons/IconLink";
import { enumNever } from "src/shared/helpers/generalHelpers";
import ShareItem from "../../components/ShareItem";
import { ShareClipboardDataType } from "./shareClipboardHelpers";
import useShareClipboard from "./useShareClipboard";

const ShareClipboard = ({ data }: { data: ShareClipboardDataType }) => {
	const { handlePress, loading, copied, copyText } = useShareClipboard(data);
	const { theme } = useStyle();
	const ShareIcon = useMemo(() => {
		const item = data[0];
		const type = item?.type ?? "Text";
		switch (type) {
			case "Url":
				return IconLink;
			case "Text":
			case "Image":
			case "LivePhoto":
				return IconClipboard;
			default:
				return enumNever(type);
		}
	}, [data]);

	return (
		<ShareItem
			Icon={!copied ? ShareIcon : IconCheck}
			name={!copied ? copyText : "Copied"}
			onPress={handlePress}
			loading={loading}
		/>
	);
};
export default ShareClipboard;
